<template>
    <div class="sa-page-search-component">
        <b-card class="sa-card sa-page-dashboard-card-body-chart" style="height: 100%" footer-tag="footer" title="">
            <b-card-header>
                <b-row>
                    <b-col :cols="btnDefault ? 3 : 4">
                        <b-form-group label="Modalità Visualizzazione" v-slot="{ ariaDescribedby }">
                            <b-form-radio-group v-model="filtro.riferimento" :options="fieldsColumn"
                                :aria-describedby="ariaDescribedby" name="Modalita Visualizzazione"
                                plain></b-form-radio-group>
                        </b-form-group>
                    </b-col>
                    <b-col :cols="btnDefault ? 3 : 4">
                        <div style="display: flex; margin-top: 25px">
                            <font-awesome-icon icon="arrow-circle-left" :disabled="disabledTrimestre"
                                style="height: 28px; width: 28px; justify-content: start; margin-right: 2px; cursor: pointer"
                                @click="indietro()" />
                            <b-form-input class="text-center" :value="getFiltroDescription()"
                                :disabled="true"></b-form-input>
                            <font-awesome-icon icon="arrow-circle-right" :disabled="disabledTrimestre"
                                style="height: 28px; width: 28px; margin-left: 2px; cursor: pointer"
                                @click="avanti()" />
                        </div>
                    </b-col>
                    <b-col cols="2">
                        <label class="sa-label-data">Data Dal</label>
                        <date-picker format="DD/MM/YYYY" :disabled="disabledFiltroDalAl" @input="loadData()"
                            value-type="timestamp" v-model="filtro.dataDal" type="date"></date-picker>
                    </b-col>
                    <b-col cols="2">
                        <label class="sa-label-data">Data Al</label>
                        <date-picker format="DD/MM/YYYY" :disabled="disabledFiltroDalAl" @input="loadData()"
                            value-type="timestamp" v-model="filtro.dataAl" type="date"></date-picker>
                    </b-col>
                    <b-col class="text-center align-content-center" cols="2" v-if="btnDefault">
                        <b-button @click="onSubmit" variant="primary">Cerca</b-button>

                    </b-col>
                </b-row>
            </b-card-header>
        </b-card>
    </div>
</template>

<script>
import moment from "moment";
import DatePicker from "vue2-datepicker";
export default {
    components: { DatePicker },
    props: {
        choiseNotVisible: {
            type: Array,
            default: () => {
                return []
            }
        },
        btnDefault: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            disabledFiltroDalAl: true,
            disabledTrimestre: false,
            dataRiferimento: new Date(),
            anno: {
                dataDal: null,
                dataAl: null,
            },
            mese: {
                dataDal: null,
                dataAl: null,
            },
            filtro: {
                riferimento: "T",
                dataDal: new Date().getTime(),
                dataAl: new Date().getTime(),
                trimestre: 1,
                anno: new Date().getFullYear(),
            },
            options: [
                { text: "Trimestre", value: "T" },
                { text: "Annuale", value: "A" },
                { text: "Periodo", value: "P" },
                { text: "Mensile", value: "M" },
            ],
            trimestri: {
                1: { dataDal: null, dataAl: null },
                2: { dataDal: null, dataAl: null },
                3: { dataDal: null, dataAl: null },
                4: { dataDal: null, dataAl: null },
            },
        };
    },
    watch: {
        "filtro.riferimento": function () {
            this.setFilter();
            this.loadData();
        },
    },
    mounted() {
        this.setTrimestri();
        this.setAnnoRicerca();
        this.setMeseRicerca();
        this.setFilter();
    },
    computed: {
        fieldsColumn() {
            let columns = this.options;
            columns = this.options.filter((value) => !this.choiseNotVisible.includes(value.value));
            return columns;
        },
    },
    methods: {
        getFiltroDescription() {
            let me = this;
            let esito = "";
            if ("T" == me.filtro.riferimento) {
                esito = this.getAnno(me.dataRiferimento) + "/" + this.getTrimestre(me.dataRiferimento);
            } else if ("P" == me.filtro.riferimento) {
                esito = "";
            } else if ("A" == me.filtro.riferimento) {
                esito = this.getAnno(me.dataRiferimento);
            } else if ("M" == me.filtro.riferimento) {
                esito = this.getMese(me.dataRiferimento);
            }
            return esito;
        },
        getAnno(data) {
            return data.getFullYear();
        },
        getMese(data) {
            return moment(data).format("MMMM").toUpperCase();
        },
        getTrimestre() {
            return moment(this.dataRiferimento).quarter();
        },
        avanti() {
            let me = this;
            if ("P" == me.filtro.riferimento) {
                return;
            }
            if ("M" == me.filtro.riferimento) {
                const giorniMeseSuccessivo = moment(this.dataRiferimento).add(1, "month").daysInMonth();
                me.dataRiferimento = new Date(me.dataRiferimento.setDate(me.dataRiferimento.getDate() + giorniMeseSuccessivo));
                this.setMeseRicerca();
                this.setFilter();
            }
            if ("T" == me.filtro.riferimento) {
                me.dataRiferimento = new Date(me.dataRiferimento.setDate(me.dataRiferimento.getDate() + 90));
                this.setTrimestri();
                this.setFilter();
            } else if ("A" == me.filtro.riferimento) {
                me.dataRiferimento = new Date(me.dataRiferimento.setDate(me.dataRiferimento.getDate() + 365));
                this.setAnnoRicerca();
                this.setFilter();
            }
            this.loadData();
        },
        indietro() {
            let me = this;
            if ("P" == me.filtro.riferimento) {
                return;
            }
            if ("M" == me.filtro.riferimento) {
                const giorniMeseSuccessivo = moment(this.dataRiferimento).add(1, "month").daysInMonth();
                me.dataRiferimento = new Date(me.dataRiferimento.setDate(me.dataRiferimento.getDate() - giorniMeseSuccessivo));
                this.setMeseRicerca();
                this.setFilter();
            }
            if ("T" == me.filtro.riferimento) {
                me.dataRiferimento = new Date(me.dataRiferimento.setDate(me.dataRiferimento.getDate() - 90));
                this.setTrimestri();
                this.setFilter();
            } else if ("A" == me.filtro.riferimento) {
                me.dataRiferimento = new Date(me.dataRiferimento.setDate(me.dataRiferimento.getDate() - 365));
                this.setAnnoRicerca();
                this.setFilter();
            }
            this.loadData();
        },
        setTrimestri() {
            let annoRiferimento = this.dataRiferimento.getFullYear();
            for (let t = 1; t <= 4; t++) {
                let inizioTrimestre = moment.utc().year(annoRiferimento).quarter(t).startOf("quarter").set({ hour: 0, minute: 0, second: 0, millisecond: 0 });
                let fineTrimestre = moment().year(annoRiferimento).quarter(t).endOf("quarter").set({ hour: 23, minute: 59, second: 59, millisecond: 0 });
                this.trimestri[t].dataDal = inizioTrimestre.valueOf();
                this.trimestri[t].dataAl = fineTrimestre.valueOf();
            }
        },
        setFilter() {
            if ("T" == this.filtro.riferimento) {
                this.disabledTrimestre = false;
                this.disabledFiltroDalAl = true;
                this.filtro.dataAl = this.trimestri[this.getTrimestre()].dataAl;
                this.filtro.dataDal = this.trimestri[this.getTrimestre()].dataDal;
            } else if ("P" == this.filtro.riferimento) {
                this.disabledFiltroDalAl = false;
                this.filtro.dataAl = new Date().getTime();
                this.filtro.dataDal = new Date().getTime();
            } else if ("A" == this.filtro.riferimento) {
                this.disabledFiltroDalAl = true;
                this.filtro.dataAl = this.anno.dataAl;
                this.filtro.dataDal = this.anno.dataDal;
            } else if ("M" == this.filtro.riferimento) {
                this.disabledFiltroDalAl = true;
                this.filtro.dataAl = this.mese.dataAl;
                this.filtro.dataDal = this.mese.dataDal;
            }
        },
        loadData() {
            this.$emit("change", this.getFilter());
        },
        setMeseRicerca() {
            let meseRiferimento = this.dataRiferimento.getMonth(); // 0-based
            let annoRiferimento = this.dataRiferimento.getFullYear();

            const inizioMese = moment.utc({ year: annoRiferimento, month: meseRiferimento, day: 1, hour: 0, minute: 0, second: 0, millisecond: 0 });
            const fineMese = moment.utc({ year: annoRiferimento, month: meseRiferimento, day: 1 }).endOf("month").set({ hour: 23, minute: 59, second: 59, millisecond: 999 });

            this.mese.dataDal = inizioMese.valueOf();
            this.mese.dataAl = fineMese.valueOf();
        },
        setAnnoRicerca() {
            let annoRiferimento = this.dataRiferimento.getFullYear();
            let inizioAnno = moment.utc().year(annoRiferimento).month(0).date(1).set({
                hour: 0,
                minute: 0,
                second: 0,
                millisecond: 0,
            });

            let fineAnno = moment().year(annoRiferimento).month(11).date(31).set({
                hour: 23,
                minute: 59,
                second: 59,
                millisecond: 0,
            });
            this.anno.dataDal = inizioAnno.valueOf();
            this.anno.dataAl = fineAnno.valueOf();
        },
        getFilter() {
            return this.filtro;
        },
        onSubmit() {
            this.$emit("submit", this.filtro)
        },
        onReset() {
            console.log("do reset");

        }
    },
};
</script>

<style>
.sa-page-search-component {
    background-color: #eff6ff !important;
    padding: 1px !important;
}

.sa-page-search-component .card,
.sa-page-search-component .card-header,
.sa-page-search-component .card-body {
    background-color: #eff6ff !important;
}

.sa-page-search-component .card {
    border: none !important;
    box-shadow: none !important;
}

.sa-page-search-component .row {
    background-color: #eff6ff !important;
}
</style>
